'use client';

import { useContext, useEffect, useRef, useState } from 'react';

import { Alter25Button } from '@/components/alter25/Alter25Button';
import { Alter25FloatingBuyNow } from '@/components/alter25/Alter25FloatingBuyNow';
import { BuyNowIcons } from '@/components/alter25/shared-marketing/BuyNowIcons';
import { ScreenSize } from '@/context/ScreenSizeContext';
import { ShopContext } from '@/context/ShopContext';
import { useIsGreaterThanOrEqual } from '@/hooks/useScreenSize';

export const SwabKitProductDetailsBuyNow: React.FC = () => {
  const { cartIsReadyForCheckout, goToCheckout } = useContext(ShopContext);
  const [isVisible, setIsVisible] = useState(true);
  const elementRef = useRef<HTMLDivElement>(null);
  const isMdOrGreater = useIsGreaterThanOrEqual(ScreenSize.md);

  useEffect(() => {
    if (!isMdOrGreater || !elementRef.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        setIsVisible(entries[0].isIntersecting);
      },
      { threshold: 0 }
    );
    if (elementRef.current) observer.observe(elementRef.current);
    return () => observer.disconnect();
  }, [isMdOrGreater]);

  return (
    <div className="mb-0 md:mb-8">
      {isMdOrGreater && (
        <>
          <div ref={elementRef}>
            <Alter25Button
              onClick={goToCheckout}
              text="Buy Now"
              size="lg"
              full
              className="mb-6"
              disabled={!cartIsReadyForCheckout}
            />
          </div>
          <BuyNowIcons />
        </>
      )}
      <Alter25FloatingBuyNow show={!isVisible || !isMdOrGreater} />
    </div>
  );
};
